import fetch from 'isomorphic-fetch';
import BaseApi from '../../../shared/javascripts/api/BaseApi'

class UserApi extends BaseApi {
  static fetchTeam(teamId) {
    return fetch(this.buildRequest(`/v1/teams/${teamId}.json`))
  }

  static fetchUsers() {
    return fetch(this.buildRequest(`/v1/users.json`))
  }
}

export default UserApi



// WEBPACK FOOTER //
// ./src/manager/javascripts/api/UserApi.js